import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { EMBED_MAX_WIDTH, EMBED_MIN_WIDTH, EMBED_WIDTH_STEP } from './embedSnippet';
import { Panel, PanelBody, PanelHead } from '../../music24/components/primitives/Panel';
import styles from './EmbedWidthControl.module.scss';

interface EmbedWidthControlProps {
  width: number;
  onChange: (width: number) => void;
}

/** The one thing the artist chooses. Everything else the page decides. */
const EmbedWidthControlComponent: React.FC<EmbedWidthControlProps> = ({ width, onChange }) => {
  const intl = useIntl();

  const onSlide = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(Number(event.target.value));
    },
    [onChange]
  );

  const label = intl.formatMessage({ id: 'app.sml.embed.width', defaultMessage: 'Width' });

  return (
    <Panel nested>
      <PanelHead title={label} right={<span className={styles.value}>{`${width}px`}</span>} />
      <PanelBody className={styles.control}>
        <input
          type="range"
          className={styles.slider}
          aria-label={label}
          min={EMBED_MIN_WIDTH}
          max={EMBED_MAX_WIDTH}
          step={EMBED_WIDTH_STEP}
          value={width}
          onChange={onSlide}
        />
        <div className={styles.bounds}>
          <span>{`${EMBED_MIN_WIDTH}px`}</span>
          <span>{`${EMBED_MAX_WIDTH}px`}</span>
        </div>
      </PanelBody>
    </Panel>
  );
};

export const EmbedWidthControl = TypedMemo(EmbedWidthControlComponent);
